/**
 * @ngdoc component
 * @name  common.shopcart.component:itxShopCartFreeShipping
 * @description
 * A component to show the free shipping on orders with a base price.
 * @param {number} freeShippingValue - Minimum value to show the leyend.
*/
(function () {

  'use strict';

  var itxShopCartFreeShippingCmp = {
      bindings: {
        freeShippingValue: '<',
        totalOrder: '<',
        showIcon:'<'
      },
      controller: itxShopCartFreeShippingCmpCtrl,
      templateUrl: 'shop-cart-free-shipping.component.html'
  };
  
  itxShopCartFreeShippingCmpCtrl.$inject = [
    'ItxTranslateSvc'
  ];
  
  function itxShopCartFreeShippingCmpCtrl(
    ItxTranslateSvc
  ) {
    var _this = this;
    
    _this.$onChanges = function () {
      // if(changeObj.freeShippingValue && isNaN(changeObj.freeShippingValue.currentValue))  {
      //   return;
      // }
      // _this.freeShippingValue = changeObj.freeShippingValue.currentValue;
      // _this.totalOrder =  changeObj.totalOrder.currentValue;
      
      _this.totalForFreeShipping = (_this.freeShippingValue - _this.totalOrder);
    };
    
    _this.howMuchToFreeShipping = function(){
      const totalForFreeShipping = inditex.formatPrice(_this.totalForFreeShipping);
      const translation  = ItxTranslateSvc.translateCms('dev.shipping.freeShippingOverRemaining', totalForFreeShipping)

        return translation
        .replace('{{ $0 }}', '<strong>'+inditex.formatPrice(_this.totalForFreeShipping)+'</strong>')
        .replace('dev.shipping.freeShippingOverRemaining', '<strong>'+inditex.formatPrice(_this.totalForFreeShipping)+'</strong>');     
    }    
  }

  angular.module('itxApp.common')
      .component('itxShopCartFreeShipping', itxShopCartFreeShippingCmp);
})();
